// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetRecommendationsByNewbuildingRequest,
  TGetRecommendationsByNewbuildingModel,
  IMappers,
  TGetRecommendationsByNewbuildingResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRecommendationsResponse } from '../../entities/get_recommendations_by_newbuilding/GetRecommendationsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetRecommendationsByNewbuildingModel(
  parameters: IGetRecommendationsByNewbuildingRequest,
): TGetRecommendationsByNewbuildingModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-recommendations-by-newbuilding/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetRecommendationsByNewbuildingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetRecommendationsByNewbuildingRequest;
}

export async function fetchGetRecommendationsByNewbuilding<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetRecommendationsByNewbuildingOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetRecommendationsByNewbuildingResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetRecommendationsByNewbuildingModel(parameters),
    config,
  )) as FetchResponse<TGetRecommendationsByNewbuildingResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRecommendationsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetRecommendationsByNewbuildingResponse>;
}
